$(".tool-layer__text--1-1").append(jsonData["text1-1"]);
$(".tool-layer__text--1-2").append(jsonData["text1-2"]);
$(".tool-layer__text--2-1").append(jsonData["text2-1"]);
if(!jsonData["input"]) $(".tool-layer").remove();


// WEBPACK FOOTER //
// ./src/js/create/tool-data.js